export default "__VITE_ASSET__Bhpr1dLW__"